export var GroupType;
(function (GroupType) {
    /**
     * registration as a member at an organization - for a specific age group (most of the time)
     */
    GroupType["Membership"] = "Membership";
    /**
     * Waiting list of any other group
     */
    GroupType["WaitingList"] = "WaitingList";
    /**
     * Activity
     */
    GroupType["EventRegistration"] = "EventRegistration";
    // idea: EventPreRegistration = "EventPreRegistration", // let know in advance that you want to join
    // idea: EventAttendance = "EventAttendance", // attendance list for an event, by admins only
})(GroupType || (GroupType = {}));
export function getGroupTypeName(type) {
    switch (type) {
        case GroupType.Membership:
            return $t('%1IL');
        case GroupType.WaitingList:
            return $t('%1IQ');
        case GroupType.EventRegistration:
            return $t('%1IR');
    }
}
//# sourceMappingURL=GroupType.js.map